/*----------------------------------
- TLD INSIGHT PAGE DATA
----------------------------------*/

/**
 * @docs docs/features/tld-intelligence
 * @adr  ADR-0062
 * @rule The one mapping from a public insight to the shared `TldPage`'s data, read by the page
 *       and its Markdown mirror, so both print the same rows. Its own module, not
 *       `presentation.ts`: the hub imports the link helpers and must not pull the country table.
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import type { PublicTldInsight } from '@uniquedomains/components/contracts/tlds/public';
import type { TldPageData } from '@uniquedomains/components/tlds/page/pageTypes';
import { resolveIsoCountryName } from '@uniquedomains/core/geo';

/*----------------------------------
- PUBLIC API
----------------------------------*/

/** The website names the operator's country in full; Product passes the bare code. */
export const toTldPageData = (insight: PublicTldInsight): TldPageData => {
    const countryCode = insight.registry.registryCountryCode;
    return {
        slug: insight.slug,
        registry: insight.registry,
        registryCountryLabel: countryCode ? resolveIsoCountryName(countryCode) ?? countryCode : null,
        quality: insight.quality,
        usage: insight.usage,
        market: insight.market,
        phases: insight.phases,
        registrars: insight.registrars,
        topics: insight.topics,
        news: insight.news,
    };
};
